export default __webpack_public_path__ + "static/logo-divio-858a2c5ac8f01870a97be8cde0672260.png";